export const isEmbedMode = (): boolean =>
    new URLSearchParams(window.location.search).get("embed") === "true";
